module.exports = __webpack_public_path__ + "img/logo.9ff3b360.png";